import { AuthError } from '@supabase/supabase-js';

/**
 * Traduit les erreurs Supabase Auth en messages lisibles (FR).
 * Supabase utilise des "error codes" récents + des messages HTTP plus anciens.
 */
export function getAuthErrorMessage(error: unknown): string {
    if (error instanceof AuthError) {
        const code = error.code ?? '';
        const status = error.status ?? 0;
        const msg = error.message ?? '';

        const byCode: Record<string, string> = {
            invalid_credentials: 'Identifiants incorrects.',
            email_not_confirmed: 'Email non confirmé. Vérifie ta boîte mail.',
            user_not_found: 'Aucun compte trouvé avec cette adresse.',
            weak_password: 'Le mot de passe doit contenir au moins 6 caractères.',
            user_already_exists: 'Un compte existe déjà avec cette adresse.',
            email_exists: 'Un compte existe déjà avec cette adresse.',
            over_email_send_rate_limit: 'Trop d\'emails envoyés récemment. Réessaie dans un moment.',
            over_request_rate_limit: 'Trop de tentatives. Réessaie dans un moment.',
            signup_disabled: 'Les inscriptions sont désactivées.',
            provider_disabled: 'Méthode de connexion non activée.',
            validation_failed: 'Données invalides. Vérifie tes informations.',
        };

        if (code && byCode[code]) return byCode[code];

        // Fallback sur le status HTTP
        if (status === 429) return 'Trop de tentatives. Réessaie dans un moment.';
        if (status === 422) return 'Données invalides. Vérifie tes informations.';

        // Fallback sur le message brut
        if (msg) return msg;
    }

    const msg = (error as { message?: string })?.message;
    return msg || 'Une erreur est survenue. Réessaie.';
}
